// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { IAssessorWebpageApiResponse, IAssessorApiPaginatedResponse } from 'interfaces/webpage/assessor/assessor-api.interface'
import { IAssessorWebpageGetAttrs } from 'interfaces/webpage/assessor/assessor-view.interface'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_assessors, withHelper_baseResponsePaginationTypes } from 'models/extensions/with-helper'

// Utils
import { commonUtils_renderTableNumber } from 'utils/common/common.utils'
import { dateUtils_formatDate } from 'utils/common/date.utils'

// Assessor List Model
const Assessors = types.model('Assessors').props(withHelper_baseResponsePaginationTypes(withHelper_assessors()))

const AssessorWebpageStore = types
  .model('AssessorWebpage')
  .props({
    assessorWebpage_isLoading: types.optional(types.boolean, false),
    assessorWebpage_webpage: types.optional(Assessors, {}),
  })
  .actions(self => ({
    assessorWebpage_SET_LOADING: (payload: boolean): void => {
      self.assessorWebpage_isLoading = payload
    },
    assessorWebpage_SET_ASSESSOR_WEBPAGE: (payload: IAssessorApiPaginatedResponse): void => {
      self.assessorWebpage_webpage = cast({
        ...payload,
        list: payload.list.map((list, index) => {
          return {
            ...list,
            number: commonUtils_renderTableNumber(index, payload),
            expiredAt: dateUtils_formatDate(list.expiredAt!, { tableFormat: true, withoutTime: true }),
          }
        }),
      })
    },
    assessorWebpage_CLEAR_ASSESSOR_WEBPAGE: (): void => {
      self.assessorWebpage_webpage = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch assessor webpage
     *
     * @param {IAssessorWebpageGetAttrs} payload
     *
     * @return {any} any
     */
    assessorWebpage_fetchAssessorWebpage: flow(function* (payload: IAssessorWebpageGetAttrs) {
      self.assessorWebpage_SET_LOADING(true)

      const response: IAssessorWebpageApiResponse = yield self.environment.assessorWebpageApi.assessorWebpage_getAssessor(payload)
      if (response.ok) self.assessorWebpage_SET_ASSESSOR_WEBPAGE(response.res.data)

      self.assessorWebpage_SET_LOADING(false)
    }),
  }))

export const createAssessorWebpageStoreDefaultModel = () => types.optional(AssessorWebpageStore, {})
